export * from './lib';
export * from './lib/domain-favourite-item.module';
